import { InjectionToken } from '@angular/core';
import { App } from '@df/core/app';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NICmsContentPageType } from '@icms/core/content/interfaces/icms-content-page-type.interfaces';
import { ICmsBlock, NICmsBlock } from '@icms/core/resource/block/icms-block';

export namespace DfHeaderUi {
    /**
     * Injection token for module options
     */
    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_HEADER_UI_OPTIONS');
    /**
     * Module options
     */
    export interface IModuleOptions {
        /**
         * CMS id of the header component
         */
        headerComponentId: string;
        /**
         * Fields and settings to activate
         */
        fields: {
            transparency?: {
                /**
                 * Classname to set
                 */
                className: string;
                /**
                 * Additional check to perform
                 * @returns boolean to force state or undefined to use default
                 */
                check?: (app: App) => boolean | undefined;
            };
            // hiding?: true
            /**
             * Header themes
             */
            theme: {
                /**
                 * List of options where
                 * id is the class name to set
                 * value is the title to display
                 *
                 * Default option is added by the system
                 */
                options: { [id: string]: string };
                /**
                 * Additional check to perform
                 * @returns string to force state or undefined to use default
                 */
                check?: (app: App) => string | undefined;
            };
        };
    }

    export namespace Field {
        export namespace Block {
            export const Title: NICmsContentField.IField = {
                key: 'styles.dfHeaderUiHeaderSectionLabel',
                type: NICmsContentField.EFieldType.label,
                title: 'Header behaviour',
                group: NICmsContentComponent.EFieldGroup.styles,
                description: 'Default header behavior on the website, which can be overwritten by page settings.'
            };

            export const Transparency: NICmsContentField.IToggleField = {
                key: 'styles.dfHeaderUiTransparent',
                labels: {
                    true: 'Transparent',
                    false: 'Not Transparent'
                },
                type: NICmsContentField.EFieldType.toggle,
                title: 'Transparency',
                group: NICmsContentComponent.EFieldGroup.styles,
                default: false
            };

            export const Theme: NICmsContentField.IChoiceField = {
                key: 'styles.dfHeaderUiTheme',
                options: [], // are injected in the module constructor
                type: NICmsContentField.EFieldType.choice,
                title: 'Theme',
                group: NICmsContentComponent.EFieldGroup.styles,
                default: ''
            };
        }
        export namespace Page {
            export enum EOverrideOption {
                default = 'default',
                on = 'on',
                off = 'off'
            }

            export const Transparency: NICmsContentPageType.IField & NICmsContentField.IChoiceField = {
                key: 'additional.dfHeaderUiTransparent',
                options: [
                    {
                        key: EOverrideOption.default,
                        title: 'Default'
                    },
                    {
                        key: EOverrideOption.on,
                        title: 'Transparent'
                    },
                    {
                        key: EOverrideOption.off,
                        title: 'Not Transparent'
                    }
                ],
                type: NICmsContentField.EFieldType.choice,
                title: 'Transparency',
                tab: 'Header Behavior',
                default: EOverrideOption.default
            };

            // export const Hiding : NICmsContentField.IToggleField = {
            //     key: 'styles.dfHeaderUiHideUp',
            //     labels: {
            //         true: 'Hide up',
            //         false: 'Persist'
            //     },
            //     type: NICmsContentField.EFieldType.toggle,
            //     title: 'On scroll down behavior',
            //     default: false
            // }

            export const Theme: NICmsContentPageType.IField & NICmsContentField.IChoiceField = {
                key: 'additional.dfHeaderUiTheme',
                options: [], // are injected in the module constructor
                type: NICmsContentField.EFieldType.choice,
                title: 'Theme',
                tab: 'Header Behavior',
                default: ''
            };
        }
    }
}

declare module '@df/catalog/catalog.interfaces' {
    namespace Catalog {
        interface IStyles {
            dfHeaderUiTransparent?: boolean;
            dfHeaderUiTheme?: string;
        }
    }
}

declare module '@icms/core/data/icms-data.interfaces' {
    namespace NICmsData {
        interface ICmsAdditionalData {
            dfHeaderUiTransparent?: DfHeaderUi.Field.Page.EOverrideOption;
            dfHeaderUiTheme?: string;
        }
    }
}
